import { createContext } from 'react';
import type { DailyCall } from '@daily-co/daily-js';
import type { DailyCallService } from '@services/dailycall';

import type { UsePatientLinkReturn } from '../hooks/usePatientLink';
import type { UsePictureInPictureReturn } from '../hooks/usePictureInPicture';
import type { ChatMessage, TelehealthSession } from '../types';
import type { ProviderWaitingRoomRuntime } from '../waiting-room';

export type TelehealthPhase = 'idle' | 'joining' | 'precall' | 'call';

export interface JoinCallParams {
  appointmentId?: string;
  encounterId: string;
  nbf?: number | string;
  exp?: number | string;
}

export interface JoinWalkInCallParams {
  encounterId: string;
  roomUrl: string;
  token: string;
  roomName?: string;
  expiresAt?: string | null;
}

export interface TelehealthCallManagerContextValue {
  session: TelehealthSession | null;
  phase: TelehealthPhase;
  activeEncounterId: string | null;
  activeAppointmentId: string | null;
  dailyCallService: DailyCallService | null;
  callObject: DailyCall | null;
  joinCall: (params: JoinCallParams) => Promise<void>;
  joinCallDirect: (params: JoinCallParams) => Promise<void>;
  joinWalkInCall: (params: JoinWalkInCallParams) => Promise<void>;
  joinDailyRoom: () => Promise<void>;
  leaveCall: () => void;
  stopRecordingAndLeave: () => Promise<void>;
  patientLink: UsePatientLinkReturn;
  waitingRoom: ProviderWaitingRoomRuntime;
  pip: UsePictureInPictureReturn;
  sendChatMessage: (message: ChatMessage) => void;
}

export const TelehealthCallManagerContext = createContext<TelehealthCallManagerContextValue | null>(
  null,
);
